/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
    shape, bool, string, arrayOf, object,
} from 'prop-types';

// Material UI
import Grid from '@material-ui/core/Grid';

// Helpers
import StatusTracking from '../../../common/StatusTracking';
import configEnv from '../../../config';

const {
    FEDEX_ORDERTRACKING_URL,
    UPS_ORDERTRACKING_URL,
    USPS_ORDERTRACKING_URL,
    UDS_ORDERTRACKING_URL,
} = configEnv;

const DesktopOrderTracking = ({
    ROSSOrder, isROSSPassport, isROSSItemStatusEnabled, IsPendingCancelEnabled, isDonationItem,
}) => {
    let ROSSTrackingUrl;

    const ROSSStatus = ROSSOrder?.status;
    const ROSSCarrier = ROSSOrder?.carrier;
    const ROSSTrackingNo = ROSSOrder?.trackingNumber;
    const ROSSDeliveryLink = ROSSOrder?.deliveryLink;
    const isCardisleProductBrand = ROSSOrder?.productBrand === '1036';
    const isCelebrationsProductBrand = ROSSOrder?.productBrand === '1038';
    const ROSSItemType = isROSSItemStatusEnabled ? ROSSOrder?.itemType : ROSSOrder?.items?.[0]?.itemType;
    const ROSSOrderPendingCancel = ROSSOrder?.pendingCancel;
    const showDelivered = isROSSPassport || isDonationItem;

    if (ROSSDeliveryLink && ROSSDeliveryLink !== '') {
        ROSSTrackingUrl = ROSSDeliveryLink;
    } else if (ROSSCarrier && ROSSTrackingNo) {
        if (ROSSCarrier === 'FEDEX') {
            ROSSTrackingUrl = FEDEX_ORDERTRACKING_URL + ROSSTrackingNo;
        } else if (ROSSCarrier === 'UPS') {
            ROSSTrackingUrl = UPS_ORDERTRACKING_URL + ROSSTrackingNo;
        } else if (ROSSCarrier === 'USPS' || ROSSCarrier === 'MAIL') {
            ROSSTrackingUrl = USPS_ORDERTRACKING_URL + ROSSTrackingNo;
        } else if (ROSSCarrier === 'UDS') {
            ROSSTrackingUrl = UDS_ORDERTRACKING_URL + ROSSTrackingNo;
        }
    }

    const openTrackingWindow = (trackingUrl) => {
        if (typeof window !== 'undefined') window.open(trackingUrl);
    };

    const showSubStatus = () => {
        const {
            statusDescription, history, type, deliveryLink, attemptedReason,
        } = ROSSOrder;

        if (type === 'FPT') {
            const isOrderDelayed = history.length > 0 && history[0].attemptedReason;
            if (isOrderDelayed) {
                return (
                    <div className="delay-container">
                        <img src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blte21ce9e1faee603c/6042a5473c41f30bce48321a/Warning_Icon.svg" alt="warning" />
                        <b>{attemptedReason}</b>
                    </div>
                );
            }
            return <b>{statusDescription}</b>;
        }

        if (type === 'GPT') {
            const isOrderDelayed = history.length > 0 && history[0].codeStatus === 'DE';
            if (isOrderDelayed) {
                return (
                    <div className="delay-container">
                        <img src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blte21ce9e1faee603c/6042a5473c41f30bce48321a/Warning_Icon.svg" alt="warning" />
                        { deliveryLink  ? (
                            <a
                                href={deliveryLink}
                                target="_blank"
                                rel="noreferrer"
                                className="bold"
                            >
                                {statusDescription}
                            </a>
                        ) : <b>{statusDescription}</b> }
                    </div>
                );
            }

            return deliveryLink ? (
                <a
                    href={deliveryLink}
                    target="_blank"
                    rel="noreferrer"
                    className="bold"
                >
                    {statusDescription}
                </a>
            ) : <b>{statusDescription}</b>;
        }
        return null;
    };

    const showCarrier = (ROSSCarrier) => {
        if (ROSSCarrier === 'FEDEX') {
            return <img alt="fedex logo" className="fedex-logo" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt986d6df1eca50df5/5f9715bf545bdb56ce4903e6/fedex-logo.svg" />;
        }
        if (ROSSCarrier === 'UDS') {
            return <img alt="uds logo" className="uds-logo" src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltc6883e40544a7af1/6165e3b4a481550b84bdc2eb/UDS_logo_1.svg" />;
        }
        return <span>{ROSSCarrier}</span>;
    };

    return (
        <>
            <Grid className={`${!isROSSItemStatusEnabled ? `${isROSSPassport ? 'desktop-status-bar bottom-border' : 'desktop-status-bar bottom-border alignCenter'}` : 'alignColumn'}`} container spacing={!isROSSItemStatusEnabled ? 3 : 1}>
                <Grid item xs={!isROSSItemStatusEnabled && 4}>
                    <StatusTracking ROSSStatus={showDelivered ? 'DELIVERED' : ROSSStatus} ROSSOrderPendingCancel={ROSSOrderPendingCancel} IsPendingCancelEnabled={IsPendingCancelEnabled} />
                </Grid>
                <Grid className="substatus-container" item xs={!isROSSItemStatusEnabled && 4}>
                    {showSubStatus()}
                </Grid>
                <Grid item xs={!isROSSItemStatusEnabled && 4} className="position-relative">
                    { ROSSItemType === 'FPT' && (
                        <div>
                            <span className="uppercase bold gray-color">
                                Delivered By:{' '}
                            </span>
                            <span>
                                Local Shop
                            </span>
                        </div>
                    )}
                    { ROSSItemType === 'GPT' && (
                        <>
                            { ROSSCarrier && (
                                <div>
                                    <span className="uppercase bold gray-color">
                                        Delivered By:{' '}
                                    </span>
                                    <span>
                                        {showCarrier(ROSSCarrier)}
                                    </span>
                                </div>
                            )}
                            {!isROSSPassport && (ROSSStatus !== 'CANCELLED') && !isDonationItem && (
                                <div>
                                    <span className="uppercase bold gray-color">
                                        Tracking:{' '}
                                    </span>
                                    {ROSSTrackingNo ? (
                                        <span>
                                            {!isCardisleProductBrand && !isCelebrationsProductBrand && ROSSTrackingUrl ? (
                                                <a
                                                    className="link"
                                                    onClick={() => openTrackingWindow(ROSSTrackingUrl)}
                                                >
                                                    {ROSSTrackingNo}
                                                </a>
                                            ) : (
                                                ROSSTrackingNo
                                            )}
                                        </span>
                                    ) : (
                                        <span>Available Once Shipped</span>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

DesktopOrderTracking.defaultProps = {
    ROSSOrder: {},
    isROSSPassport: false,
};

DesktopOrderTracking.propTypes = {
    ROSSOrder: shape({
        actualDeliveryDate: string,
        address: string,
        carrier: string,
        courier: string,
        createdDate: string,
        currentLocation: object,
        deliveryDate: string,
        deliveryImageURL: string,
        deliveryMethod: string,
        deliveryNotes: string,
        type: string,
        statusDescription: string,
        history: arrayOf(shape({
            codeStatus: string,
            createdDate: string,
            location: object,
            status: string,
            statusDescription: string,
        })),
        intOrderNumber: string,
    }),
    isROSSPassport: bool,
    isDonationItem: bool.isRequired,
};

export default DesktopOrderTracking;
